const EXAMPLES_API_BASE_URL = 'https://numericalaiapi.fetchcfd.com/pyfr/templates';


class ExamplesApiService {
  constructor() {
    this.baseURL = EXAMPLES_API_BASE_URL;
  }

  getHeaders() {
    const headers = { 'Content-Type': 'application/json' };
    const token = localStorage.getItem('access_token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
  }

  async handleResponse(response) {
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  async getExamples() {
    const response = await fetch(`${this.baseURL}/`, {
      headers: this.getHeaders(),
    });
    return this.handleResponse(response);
  }

  async getExampleCategory(tag) {
    const response = await fetch(`${this.baseURL}/${tag}`, {
      headers: this.getHeaders(),
    });
    return this.handleResponse(response);
  }

  async getExampleFile(tag, exampleName, fileType) {
    const response = await fetch(
      `${this.baseURL}/${tag}/${exampleName}/${fileType}`,
      { headers: this.getHeaders() }
    );
    return this.handleResponse(response);
  }

  /**
   * Request an industry executive brief PDF by email (Turnstile + form).
   * POST /templates/executive-briefs — public; optional Bearer if signed in.
   */
  async requestExecutiveBrief({
    full_name,
    email,
    company,
    use_case,
    message,
    turnstile_token,
  }) {
    const body = {
      full_name,
      email,
      company,
      use_case,
      turnstile_token,
      ...(message != null && String(message).trim() !== ''
        ? { message: String(message).trim() }
        : {}),
    };
    const token = localStorage.getItem('access_token');
    const headers = {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    const response = await fetch(`${this.baseURL}/executive-briefs`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const detail = errorData.detail;
      let messageErr = `Request failed (${response.status})`;
      if (typeof detail === 'string') {
        messageErr = detail;
      } else if (Array.isArray(detail) && detail[0]?.msg) {
        messageErr = detail.map((d) => d.msg).filter(Boolean).join(' ') || messageErr;
      } else if (detail && typeof detail === 'object' && detail.msg) {
        messageErr = detail.msg;
      }
      const err = new Error(messageErr);
      err.status = response.status;
      throw err;
    }
    return response.json();
  }
}

const examplesApiService = new ExamplesApiService();
export default examplesApiService;
